import { V3Record } from "data/helpers/V3Record.js";

export const TmsJob = V3Record("tmsJob", {
  gengoOrderId: null,
  pullRequestId: null,
  sha: null,
  project: null,
  createdAt: null,
  updatedAt: null,
});
